import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, MapPin } from 'lucide-react';

/**
 * Placeholder Impressum / Note Legali page.
 * Da completare con i dati ufficiali dell'azienda prima del lancio commerciale.
 */
export const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-8 px-4" data-testid="impressum-page">
      <div className="max-w-3xl mx-auto bg-white shadow-sm rounded-xl border border-slate-200 p-6 sm:p-10">
        <Link
          to="/login"
          className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-slate-900 mb-6"
          data-testid="impressum-back-link"
        >
          <ArrowLeft className="h-4 w-4" />
          Torna al login
        </Link>

        <header className="border-b border-slate-200 pb-5 mb-6">
          <h1 className="text-3xl font-semibold text-slate-900">Impressum</h1>
          <p className="text-slate-600 mt-1">Note legali — BollettinoX</p>
        </header>

        <div className="space-y-6 text-sm leading-relaxed text-slate-700">
          <section>
            <h2 className="text-base font-semibold text-slate-900 mb-2">Titolare del sito</h2>
            <p className="font-medium">Luca Genovese</p>
            <p className="flex items-center gap-1.5 text-slate-600">
              <MapPin className="h-4 w-4" /> Lugano, Canton Ticino, Svizzera
            </p>
            <p className="flex items-center gap-1.5 text-slate-600">
              <Mail className="h-4 w-4" />
              <a href="mailto:info@bollettinox.ch" className="underline hover:text-slate-900">info@bollettinox.ch</a>
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-slate-900 mb-2">Numero di iscrizione al Registro di Commercio</h2>
            <p className="text-slate-500 italic">— da completare prima del lancio commerciale —</p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-slate-900 mb-2">Numero IVA / P.IVA</h2>
            <p className="text-slate-500 italic">— da completare prima del lancio commerciale —</p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-slate-900 mb-2">Esclusione di responsabilità</h2>
            <p>
              L&apos;autore non si assume alcuna responsabilità per la correttezza, l&apos;accuratezza, l&apos;attualità,
              l&apos;affidabilità e la completezza delle informazioni pubblicate.
              Pretese di responsabilità nei confronti dell&apos;autore per danni di natura materiale o immateriale
              risultanti dall&apos;accesso o dall&apos;utilizzo o dal mancato utilizzo delle informazioni pubblicate,
              dall&apos;abuso del collegamento o da disfunzioni tecniche sono escluse.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-slate-900 mb-2">Diritti d&apos;autore</h2>
            <p>
              I diritti d&apos;autore e qualsiasi altro diritto relativo a testi, illustrazioni, foto o altri file
              presenti su questo sito sono di esclusiva proprietà di BollettinoX o degli aventi diritto specificatamente
              menzionati. Per la riproduzione di qualsiasi elemento è necessario ottenere preventivamente il consenso
              scritto del titolare dei diritti.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-slate-900 mb-2">Foro competente</h2>
            <p>
              Per qualsiasi controversia relativa all&apos;utilizzo di questo sito si applica il diritto svizzero
              ed è competente il Foro di Lugano.
            </p>
          </section>
        </div>

        <p className="mt-10 text-xs text-slate-500 italic">Ultimo aggiornamento: giugno 2026</p>
      </div>
    </div>
  );
};

export default ImpressumPage;
